(function () {
  document.querySelectorAll('[data-alive-carousel]').forEach(function (root) {
    if (root.dataset.aliveCarouselInit) return;
    root.dataset.aliveCarouselInit = 'true';

    var track = root.querySelector('[data-alive-carousel-track]');
    var dotsWrap = root.querySelector('[data-alive-carousel-dots]');
    var prevBtn = root.querySelector('[data-alive-carousel-prev]');
    var nextBtn = root.querySelector('[data-alive-carousel-next]');
    if (!track) return;

    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;

    var dots = [];
    if (dotsWrap) {
      items.forEach(function (item, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'alive-carousel__dot';
        dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
        dot.addEventListener('click', function () {
          item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function updateActive() {
      var trackLeft = track.getBoundingClientRect().left;
      var closest = 0;
      var closestDist = Infinity;
      items.forEach(function (item, i) {
        var dist = Math.abs(item.getBoundingClientRect().left - trackLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === closest);
      });
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(updateActive, 90);
    }, { passive: true });

    function step(dir) {
      var amount = items[0].getBoundingClientRect().width + 18;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    updateActive();
  });
})();
